module.exports = __webpack_public_path__ + "static/media/parse_logo_yellow.5797b22f.png";